import MomentAnalyticsHome from '../../components/moment/MomentAnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction, setShowAnonymousUsers } from '../../modules';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
  setShowAnonymousUsers(data) {
    dispatch(setShowAnonymousUsers(data));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listInteractions: _.get(state, 'analytics.listInteractions', []),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
    showAnonymousUsers: _.get(state, 'analytics.showAnonymousUsers', true),
  };
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('momentsList', 'setMomentsList', []),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
    getMoments: props => () => {
      API.getInteractions().then(({ data }) => {
        if (data && data.docs) {
          props.setMomentsList(data.docs);
        }
      });
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      this.props.getMoments();
    },
  })
);

export default enhance(MomentAnalyticsHome);
